import { useContext } from 'react';

import ConfirmDialogContext from './ConfirmDialogContext';

const useConfirmDialog = () => {
  return useContext(ConfirmDialogContext);
};

export default useConfirmDialog;
